import FilterOperatorOwnerInput from 'customer-data-filters-ui/components/operator/FilterOperatorOwnerInput';
import { jsx as _jsx } from "react/jsx-runtime";
const OwnerInputWithMeOption = props => /*#__PURE__*/_jsx(FilterOperatorOwnerInput, Object.assign({}, props, {
  requestOptions: {
    includeInactive: false
  }
}));
export default {
  InputComponent: OwnerInputWithMeOption
};